
import { Component, Vue, Emit } from "vue-property-decorator";
import { AuthStoreNamespace } from "@/modules/auth/store/auth.store";
import { AuthState } from "@/modules/auth/store/auth.definitions";
import AppButton from "@/modules/shared/components/AppButton.vue";
import AppCard from "@/modules/shared/components/AppCard.vue";
import AppIcon from "@/modules/shared/components/AppIcon.vue";

@Component({
  components: {
    AppIcon,
    AppButton,
    AppCard,
  },
})
export default class AppNavbarProfile extends Vue {
  @AuthStoreNamespace.State
  private readonly user!: AuthState["user"];

  public get email(): string {
    return this.user?.email || "";
  }

  @Emit()
  public onLogout(): void {}
}
